module.exports = __webpack_public_path__ + "img/data-deduplication.457c7cca.png";